import { useQuery } from '@tanstack/react-query';

/* eslint-disable max-lines */
import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { getServicingCategories } from '../service';

function useServicingCategories() {
    const query = useQuery({
        queryKey: ['categories'],
        queryFn: () => getServicingCategories(),
    });

    return query;
}

function useServicingCategoryFilter({
    onChange = () => {},
}: {
    onChange?: () => void;
} = {}) {
    const [searchParams, setSearchParams] = useSearchParams();

    const setServicingCategories = (categories: string[]) => {
        setSearchParams((params) => {
            // clear all previous categories
            params.delete('category');

            // add all selected categories
            for (const cat of categories) {
                params.append('category', cat);
            }

            return params;
        }, {
            replace: true,
        });

        onChange();
    };

    const servicingCategories = useMemo(
        () => searchParams.getAll('category').filter(Boolean),
        [searchParams]
    );

    return {
        servicingCategories,
        setServicingCategories,
    };
}

export { useServicingCategories, useServicingCategoryFilter };
